import { post } from '../utils';

export default function burialPoint(url: string, data: Object): void {
    post(url, data).then((rd) => {
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/burialPoint.ts